import { Message } from 'semantic-ui-react';
import { useCallback, useEffect, useState } from 'react';
import { fetchQuestions } from './questionFormService';
import { QuestionsFormsContent } from './QuestionsFormsContent';

export const Questions = () => {
    const [questions, setQuestions] = useState(null);
    const [error, setError] = useState('');

    const loadQuestions = useCallback(async () => {
        setError('');
        try {
            const data = await fetchQuestions();
            setQuestions(data);
        } catch (err) {
            setError(err.message);
            setQuestions([]);
        }
    }, []);

    useEffect(() => {
        loadQuestions();
    }, [loadQuestions]);

    return (
        <div>
            {error !== '' && (
                <Message style={{ width: 'fit-content' }} compact negative>{error}</Message>
            )}
            <QuestionsFormsContent questions={questions} onRefresh={loadQuestions} />
        </div>
    );
};
